import { useEffect, useReducer, useRef } from 'react'
import http from '../http-common'

export default function useConfig(category = 'all', value3, active = true) {
  const cache = useRef({})

  const initialState = {
    status: 'idle',
    error: null,
    data: [],
  }

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'FETCHING':
        return { ...initialState, status: 'fetching' }
      case 'FETCHED':
        return { ...initialState, status: 'fetched', data: action.payload }
      case 'FETCH_ERROR':
        return { ...initialState, status: 'error', error: action.payload }
      case 'LOGGED_OUT':
        return { ...initialState, status: 'loggedOut', error: action.payload }
      default:
        return state
    }
  }, initialState)

  useEffect(() => {
    let cancelRequest = false
    if (!category) return

    const fetchData = async () => {
      dispatch({ type: 'FETCHING' })
      if (cache.current[category.toString()]) {
        const data = cache.current[category.toString()]
        dispatch({ type: 'FETCHED', payload: data })
      } else {
        try {
          const response = await http.get(`/config/${category}`, {
            params: { active: active, value3: value3 },
          })
          const data = response.data
          cache.current[category.toString()] = data
          if (cancelRequest) return
          dispatch({ type: 'FETCHED', payload: data })
        } catch (error) {
          if (cancelRequest) return
          if (error.response) {
            if (error.response.status === 401) {
              dispatch({ type: 'LOGGED_OUT', payload: error.response.data })
              return
            }
            dispatch({ type: 'FETCH_ERROR', payload: error.response.data })
            return
          }
          dispatch({ type: 'FETCH_ERROR', payload: error.message })
        }
      }
    }

    fetchData()

    return () => {
      cancelRequest = true
    }
  }, [category, value3, active])

  return state
}
